<template>
    <div class="bax-form-wrapper">
        <div class="d-flex bax-search-element">
            <div class="bax-form-element">
                <input
                    type="search"
                    placeholder="Type to search"
                    v-on:keyup.enter="$emit('onEnter')"
                    :value="keyword"
                />
            </div>
            <div class="bax-form-elemnt">
                <button type="submit"><i class="icon-search"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputSearch',
    props: {
        keyword: {},
    },
};
</script>

<style scoped>
</style>
